import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import SelectFilter from "react-select";

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "../MyButton";

const myLib = require("../../lib/MyLib");
const server = require("../../lib/server");
const danhmuc = require("../../lib/DanhMucLayer");
function defaultRecord(makv) {
  var d = {
    MaKV: makv,
    DC_Huong1: 0,DC_TocDo1: 0,Gio_Huong1: 0,Gio_TocDo1: 0,TT_Min1: 0,TT_Max1: 0,GhiChu1: '',
    DC_Huong2: 0,DC_TocDo2: 0,Gio_Huong2: 0,Gio_TocDo2: 0,TT_Min2: 0,TT_Max2: 0,GhiChu2: '',
    DC_Huong3: 0,DC_TocDo3: 0,Gio_Huong3: 0,Gio_TocDo3: 0,TT_Min3: 0,TT_Max3: 0,GhiChu3: '',
    DC_Huong4: 0,DC_TocDo4: 0,Gio_Huong4: 0,Gio_TocDo4: 0,TT_Min4: 0,TT_Max4: 0,GhiChu4: '',

    DC_Huong5: 0,DC_TocDo5: 0,Gio_Huong5: 0,Gio_TocDo5: 0,TT_Min5: 0,TT_Max5: 0,GhiChu5: '',
    DC_Huong6: 0,DC_TocDo6: 0,Gio_Huong6: 0,Gio_TocDo6: 0,TT_Min6: 0,TT_Max6: 0,GhiChu6: '',
    DC_Huong7: 0,DC_TocDo7: 0,Gio_Huong7: 0,Gio_TocDo7: 0,TT_Min7: 0,TT_Max7: 0,GhiChu7: '',
    DC_Huong8: 0,DC_TocDo8: 0,Gio_Huong8: 0,Gio_TocDo8: 0,TT_Min8: 0,TT_Max8: 0,GhiChu8: '',

    DC_Huong9: 0,DC_TocDo9: 0,Gio_Huong9: 0,Gio_TocDo9: 0,TT_Min9: 0,TT_Max9: 0,GhiChu9: '',
    DC_Huong10: 0,DC_TocDo10: 0,Gio_Huong10: 0,Gio_TocDo10: 0,TT_Min10: 0,TT_Max10: 0,GhiChu10: '',
    DC_Huong11: 0,DC_TocDo11: 0,Gio_Huong11: 0,Gio_TocDo11: 0,TT_Min11: 0,TT_Max11: 0,GhiChu11: '',
    DC_Huong12: 0,DC_TocDo12: 0,Gio_Huong12: 0,Gio_TocDo12: 0,TT_Min12: 0,TT_Max12: 0,GhiChu12: '',
  };
  return d;
}
//chuyen doi cau truc data tu server
function chuyenDoi(sv) {
  var d = defaultRecord(0);
  sv.map((item, index) => {
    d.MaKV = item.MaKV;
    d["DC_Huong" + item.Thang] = item.DC_Huong;
    d["DC_TocDo" + item.Thang] = item.DC_TocDo;
    d["Gio_Huong" + item.Thang] = item.Gio_Huong;
    d["Gio_TocDo" + item.Thang] = item.Gio_TocDo;
    d["TT_Min" + item.Thang] = item.TT_Min;
    d["TT_Max" + item.Thang] = item.TT_Max;
  });
  return d;
}
class ThoiTietDialog extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.state = {
      open: props.visible,
      fullWidth: true,
      maxWidth: "xl",
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      loading_tausar: true, // co dang load ding danh muc nguon tin ko
      source_tausar: [], //danh muc options cho nguon tin
      before:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
            }
          : myLib.cloneObject(props.value), //thong tin truoc khi edit
      after:
        props.value === undefined
          ? defaultRecord(this.props.MaKV)
          : props.value, //thong tin dang edit
      validateStatus: { error: false }, //trang thai validate
    };
  }

  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = true;
    s.canSaved = s.dataChanged;
    this.setState(s);
  };
  getDataToSave = () => {
    var d = {
      MaKV: this.state.after.MaKV,
      DC_Huong: [],
      DC_TocDo: [],
      Gio_Huong: [],
      Gio_TocDo: [],
      TT_Min: [],
      TT_Max: [],
      GhiChu: [],
    };
    [1,2,3,4,5,6,7,8,9,10,11,12].map((thang, index) => {
      d.DC_Huong.push(this.state.after['DC_Huong' + thang]);
      d.DC_TocDo.push(this.state.after['DC_TocDo' + thang]);
      d.Gio_Huong.push(this.state.after['Gio_Huong' + thang]);
      d.Gio_TocDo.push(this.state.after['Gio_TocDo' + thang]);
      d.TT_Min.push(this.state.after['TT_Min' + thang]);
      d.TT_Max.push(this.state.after['TT_Max' + thang]);
      d.GhiChu.push(this.state.after['GhiChu' + thang]);
    });
    return d;
  }
  //submit thong tin ve DB
  handleSave = () => {
    if (this.props.EditMode !== "xoa") {
      var check = {error: false};
      console.log("check", check);
      if (!check.error) {
        //console.log(JSON.stringify(this.state.after));
        this.setState({ validateStatus: check, saving: true, errorLog: "" });
        server
          .post("thoitiet/save", this.getDataToSave())
          .then((response) => {
            var before = {};
            var after = { ...this.state.after};
            Object.assign(before, after);
            this.setState({
              before: before,
              after: after,
              dataChanged: false,
              canSaved: false,
              saving: false,
              errorLog: "",
              saved: true,
            });
            this.handleClose(true);
          })
          .catch((error) =>
            this.setState({ saving: false, errorLog: error + "" })
          );
      } else {
        this.setState({ validateStatus: check });
      }
    } else {
      
    }
  };
  componentDidMount() {
    this.loadDanhMuc();
    this.loadEdit();
  }
  loadDanhMuc() {
    //load danh muc doi tac
    /*
    server
      .query("tausar/getall")
      .then((response) => {
        var list = [];
        response.map((item, index) =>
          list.push({ value: item.TenTau, label: item.TenTau })
        );
        this.setState({ source_tausar: list, loading_tausar: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_tausar: false });
      });*/
  }
  loadEdit() {
    //kiem tra xem co phai che do edit hay khong
    var mask = this.props.MaKV;
    if (mask !== undefined) {
      //load va hien thi thong tin su kien
      server
        .query("thoitiet/get?maso=" + mask)
        .then((response) => {
          //thong tin su kien
          var sukien = chuyenDoi(response);

          this.setState({
            formReady: true,
            before: sukien,
            after: sukien,
          });
          console.log("ket qua truy van", sukien);
        })
        .catch((error) => {
          console.log(error);
          this.setState({ loading_tainan: false, errorLog: error + "" });
        });
    } else {
      this.setState({ formReady: true });
    }
  }
  handleClose = (result) => {
    this.setState({ open: false });
    if (this.props.onClose) {
      this.props.onClose(result);
    }
  };
  static getDerivedStateFromProps(props, state) {
    return { ...state };
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <React.Fragment>
        <Dialog
          fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle id="max-width-dialog-title">
            <AppBar position="static">
              <Toolbar>
                <IconButton
                  edge="start"
                  className={classes.menuButton}
                  color="inherit"
                  aria-label="menu"
                >
                  <MenuIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                  Thời tiết tại khu vực biển
                </Typography>
                <Button
                  color="inherit"
                  onClick={() => this.handleClose(this.state.saved === true)}
                >
                  Thoát
                </Button>
              </Toolbar>
            </AppBar>
          </DialogTitle>
          <DialogContent>
            <form className={classes.form} noValidate autoComplete="off">
              <div style={{ height: 600 }}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(
                      (thang, index) => {
                        return (
                          <Grid key={"k" + index} item xs={12}>
                              <TextField
                                id="txtGhiChu"
                                className={classes.textbox}
                                label={"Tháng " + thang}
                                type="text"
                                value={this.state.after['GhiChu' + thang]}
                                onChange={(event) =>
                                  this.saveField("GhiChu" + thang, event.target.value)
                                }
                              />
                              <TextField
                                id="txtDC_Huong"
                                className={classes.textbox}
                                label="Dòng chảy - hướng:"
                                type="number"
                                value={this.state.after['DC_Huong' + thang]}
                                onChange={(event) =>
                                  this.saveField("DC_Huong" + thang, event.target.value)
                                }
                              />
                              <TextField
                                id="txtDC_TocDo"
                                className={classes.textbox}
                                label="Dòng chảy - tốc độ:"
                                type="number"
                                value={this.state.after['DC_TocDo' + thang]}
                                onChange={(event) =>
                                  this.saveField("DC_TocDo" + thang,event.target.value)
                                }
                              />
                              <TextField
                                id="txtGio_Huong"
                                className={classes.textbox}
                                label="Gió - hướng:"
                                type="number"
                                value={this.state.after['Gio_Huong' + thang]}
                                onChange={(event) =>
                                  this.saveField("Gio_Huong" + thang,event.target.value)
                                }
                              />
                              <TextField
                                id="txtGio_TocDo"
                                className={classes.textbox}
                                label="Gió - tốc độ:"
                                type="number"
                                value={this.state.after['Gio_TocDo' + thang]}
                                onChange={(event) =>
                                  this.saveField("Gio_TocDo" + thang, event.target.value)
                                }
                              />
                              <TextField
                                id="txtTT_min"
                                className={classes.textbox}
                                label="Thủy triều - Min:"
                                type="number"
                                value={this.state.after['TT_Min' + thang]}
                                onChange={(event) =>
                                  this.saveField("TT_Min" + thang, event.target.value)
                                }
                              />
                              <TextField
                                id="txtTT_Max"
                                className={classes.textbox}
                                label="Thủy triều - Max:"
                                type="number"
                                value={this.state.after['TT_Max' + thang]}
                                onChange={(event) =>
                                  this.saveField("TT_Max" + thang, event.target.value)
                                }
                              />
                          </Grid>
                        );
                      }
                    )}
                  </Grid>
                  <Grid item xs={2}>
                    {this.state.canSaved && this.props.EditMode !== "xoa" ? (
                      <MyButton
                        onClick={this.handleSave}
                        color="primary"
                        text="Lưu"
                      />
                    ) : null}
                  </Grid>
                  <Grid item xs={10}>
                    {this.state.saving ? (
                      <CircularProgress />
                    ) : this.state.errorLog === "" ? null : (
                      this.state.errorLog
                    )}
                  </Grid>
                </Grid>
              </div>
            </form>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
const styles = (theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 20,
    marginRight: 1,
    width: 160,
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
  },
  expandedPanel: {
    backgroundColor: "skyblue",
  },
  labelThang: {
    width: 110,
  }
});
export default withStyles(styles, { withTheme: true })(ThoiTietDialog);
